// Aggiungi questa nuova componente in un file separato o nello stesso file
import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from "@mui/material";
import { I18n } from "aws-amplify/utils";
function AddLanguageDialog({ open, onClose, onSave }) {
  const [language, setLanguage] = useState("");

  const handleSave = () => {
    if (language.trim()) {
      onSave(language.trim());  // Passa la lingua inserita al componente padre
      onClose();
      setLanguage("");  // Resetta il campo di testo dopo il salvataggio
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{I18n.get('Add a New Language')}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label={I18n.get('Language')}
          fullWidth
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{I18n.get('Cancel')}</Button>
        <Button onClick={handleSave} color="primary">{I18n.get('Save')}</Button>
      </DialogActions>
    </Dialog>
  );
}


export default AddLanguageDialog;
